import React, { ReactNode, createContext, useEffect, useState } from 'react';
import authApi from '../api/auth';

export const AuthContext = createContext<any>({});

interface LoginDetails {
  username: string;
  password: string;
}

type Props = { children: ReactNode };

export const AuthProvider = ({ children }: Props) => {
  // const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState({});

  useEffect(() => {
    const userString = localStorage.getItem('user');
    let userJSON = {};
    if (userString) userJSON = JSON.parse(userString);
    setUser(userJSON);
  }, []);

  const login = async (loginDetails: LoginDetails) => {
    // Perform the login logic
    try {
      const { data } = await authApi.login(loginDetails.username, loginDetails.password);
      localStorage.setItem('accessToken', data.access_token);
      localStorage.setItem('refreshToken', data.refresh_token);
      localStorage.setItem('user', JSON.stringify(data.user));
      return data;
    } catch (e) {
      throw e;
    }
  };

  // const user = () => {
  //   const userString = localStorage.getItem('user');
  //   let user = {};
  //   if (userString) user = JSON.parse(userString);
  //   return user;
  // };

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    // Perform the logout logic
  };

  const checkAuth = () => {
    // Check if the user is authenticated
    const token = localStorage.getItem('accessToken');
    if (token) {
      return true;
    } else {
      return false;
    }
  };
  return <AuthContext.Provider value={{ login, logout, checkAuth, user }}>{children}</AuthContext.Provider>;
};
